import React, { useState, useMemo, useCallback } from 'react';

import { DEFAULT_ITEMS_ON_PAGE, DEFAULT_PAGE } from '../constants';

type Props<T> = {
  items: T[];
  itemsOnPage?: number;
  defaultPage?: number;
};

export const usePagination = <T>({
  items,
  defaultPage = DEFAULT_PAGE,
  itemsOnPage = DEFAULT_ITEMS_ON_PAGE,
}: Props<T>) => {
  const [page, setPage] = useState(defaultPage);

  const itemsByPage = useMemo(() => {
    if (items.length === itemsOnPage) {
      return items;
    }

    return items.slice(itemsOnPage * (page - 1), itemsOnPage * page);
  }, [page, items, itemsOnPage]);

  const handleChangePage = useCallback((_: unknown, page: number) => {
    setPage(page);
  }, []);

  return { itemsByPage, page, setPage, onChangePage: handleChangePage };
};
